/// CPF `000.000.000-00` ou CNPJ `00.000.000/0000-00`, formatando o que houver até ali.
export function formatBrazilianDocument(digits: string, kind: 'CPF' | 'CNPJ'): string {
  if (kind === 'CPF') {
    const value = digits.slice(0, 11);
    return value
      .replace(/^(\d{3})(\d)/u, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/u, '$1.$2.$3')
      .replace(/\.(\d{3})(\d{1,2})$/u, '.$1-$2');
  }
  const value = digits.slice(0, 14);
  return value
    .replace(/^(\d{2})(\d)/u, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/u, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/u, '$1.$2.$3/$4')
    .replace(/\/(\d{4})(\d{1,2})$/u, '/$1-$2');
}
